import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';
import { withSpinner } from 'src/common/components/with-spinner/with-spinner';
import { popEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import XLRLogger from 'src/common/helpers/logger';
import { LOGOUT_MODAL } from 'src/menu-panel/components/menu-panel/menu-panel';
import { popupMessage } from 'src/messages/business-logic/popup-message';
import { getMetaData } from 'src/xlr-configuration/pos-service-type-utils';
import { SessionStorage } from '../../common/helpers/session-storage';
import { store } from '../../common/redux/configure-store';
import { LoginActions } from '../../common/redux/reducers/login-reducer';
import { POSModeActions } from '../../common/redux/reducers/pos-mode-reducer';
import { getLatestTransaction } from '../../home-page/business-logic/get-latest-transanction';
import { logout } from '../../home-page/business-logic/logout';
import { updateTouchPointConfiguration } from '../../touchpoint/business-logic/touchpoint-configuration';
import { logOff } from './service/idm-logoff';
import { exitTrainingMode } from './service/set-training-mode';
import { shiftEnd } from './service/shift-end-service';

export const signOff = async (
  trainingMode?: boolean,
  forceSignOff?: boolean,
  iamSignOff?: () => any,
): Promise<boolean> => {
  const {
    notifyShift,
    serverSideExitTrainingMode,
    transactionLookupSupported,
  } = getCurrentXLRConfig();
  let isSignOffSuccess = false;
  if (!store.getState().transaction.transactionId) {
    await withSpinner(async () => {
      if (notifyShift) {
        await notifyCashierShiftEnded();
      }

      const { EDGE_IAM } = getMetaData().xlrConfig;

      try {
        const user = store.getState().user;
        if (EDGE_IAM) {
          iamSignOff && (await iamSignOff());
          await logOff(user);
        } else {
          await logOff(user);
        }
        isSignOffSuccess = true;
        // this will logout anyway
        await updateDataAndOutcome();
        if (trainingMode) {
          store.dispatch(POSModeActions.setTrainingState(false));
          if (serverSideExitTrainingMode) {
            await exitTrainingMode(true);
          }
          const sessionId = SessionStorage.sessionId();
          if (sessionId) {
            store.dispatch(LoginActions.updateUserToken(sessionId));
          }
          if (!forceSignOff && transactionLookupSupported) {
            await getLatestTransaction();
          }
        }
      } catch (err) {
        isSignOffSuccess = false;
        popEmeraldModal(LOGOUT_MODAL);
        popupMessage(err);
      }
    });
  }

  return isSignOffSuccess;
};

const notifyCashierShiftEnded = async (): Promise<void> => {
  // if (signOffCashierShiftEndStrategy.IsNotifyShiftEnd())
  shiftEnd().catch(err => {
    XLRLogger.error({
      message: `ShiftEndCommand: Failed notifying cashier shift end, but continue execution. Ex :${err.Message}`,
      source: 'sign-off.ts',
    });
  });
};

export const updateDataAndOutcome = async (): Promise<void> => {
  await logout();

  updateSession();
  await updateTouchPointConfiguration()
    .then()
    .catch(err => {
      XLRLogger.error({
        message: `SignOffCommand failed to UpdateTouchPoint , Ex :${err.Message} `,
        source: 'sign-off.ts',
      });
    });

  // if (_unloadEPS) _epsProxy.UnloadEPS();
};

const updateSession = (): void => {
  const sessionId = SessionStorage.sessionId();
  if (sessionId) {
    store.dispatch(
      LoginActions.setLogin({
        sessionId: sessionId,
      }),
    );
  }
};
